import React, {useImperativeHandle} from 'react'
import {Grid, GridRow} from "semantic-ui-react"
import DropDown from "../../../../components/commonComponents/formComponents/dropDown";
import InputField from '../../../../components/commonComponents/formComponents/inputField';
import { processIndicatorVal } from '../mockConstants';
import ExportErrorMock from './ExportErrorMock';
import ProcessInd4 from './ProcessInd4'

const ExportFieldsMock = ({reference, propMRN}) => {
    const indicator4Ref = React.useRef(null);
    const errorMockRef = React.useRef(null);
    const [processIndicator, setProcess] = React.useState();
    const [acceptanceDate, setAcceptanceDate] = React.useState(() => new Date());
    const [MRN, setMRN] = React.useState(propMRN ? propMRN : "");
    useImperativeHandle(reference, () => ({
        getUpdateResponseData: () => {
            return {common: {processIndicator, acceptanceDate: Number(acceptanceDate.setHours(0,0,0,0)) / 1000, MRN}, errorMock: errorMockRef.current?.getErrorData(), 
                indicator4: indicator4Ref.current?.getProcess4Data()
            }
        },
    }));
    return ( 
        <Grid>
            <Grid.Row className="entry-number-row">
                <Grid.Column width={5}>
                    <DropDown 
                        style={{"borderColor": "#1765AE"}}
                        type="text"
                        id='processIndicator'
                        label="Process Indicator"
                        className="status-dropdown field-bg dropdown100"
                        data={processIndicatorVal}
                        value={processIndicator === -1 ? "SELECT" : processIndicator}
                        onChange={(value) => setProcess(value)}
                    />
                </Grid.Column>
            </Grid.Row>
            {processIndicator === "2" && <ExportErrorMock ref={errorMockRef} />}
            {(processIndicator === "4" || processIndicator === "5" || processIndicator === "6" || processIndicator === "P") && (<Grid.Row>
                <Grid.Column>
                    <InputField
                        isLabel={false}
                        id="acceptanceDate"
                        className={'field-bg'}
                        type="date"
                        label="Acceptance Date"
                        disabled={true}
                        value={acceptanceDate}
                        onChange={(value) => setAcceptanceDate(value)}
                    />
                </Grid.Column>
            </Grid.Row>)}
            {processIndicator === "4" && <ProcessInd4 ref={indicator4Ref}/> }
            <Grid.Row>
            <Grid.Column width={6} className={`row-ur-mrn`}>
                <InputField
                    isLabel={false}
                    id="ur-mrn"
                    className={'field-bg ur-mrn'}
                    label="MRN"
                    value={MRN}
                    onChange={(value) => setMRN(value)}
                />
                </Grid.Column>
            </Grid.Row>

        </Grid>
     );
}
 
export default ExportFieldsMock;